<template>
  <div class="flex items-center justify-center w-full mt-6">
    <div class="grid grid-cols-2 lg:grid-cols-3 gap-4 w-full">
      <button v-for="(brand, i) in brands" :key="i" @click="selectBrand(brand)">
        <div
          class="flex items-center justify-center border-2 hover:border-blue-400 hover:cursor-pointer rounded-2xl p-5 h-36 md:h-40"
        >
          <img
            class="w-[60%] max-w-[150px] min-w-[70px]"
            :src="carImage(brand)"
            alt=""
          />
        </div>
        <p class="mt-1 font-semibold text-center">{{ brand }}</p>
      </button>
    </div>
  </div>
</template>

<script>
import carsData from "../cars.json";

export default {
  name: "AvailableBrands",
  props: {
    brands: {
      type: Array,
      required: true,
    },
  },
  methods: {
    carImage(brand) {
      const car = carsData.find((car) => car.name === brand);
      return car.image.thumb;
    },
    selectBrand(brand) {
      this.$emit("brand-select", brand);
    },
  },
};
</script>
